module.exports = __webpack_public_path__ + "media/images/autopilot/connect_calendar-97d5dd871520c01b5422002a86ddff2c.png";